import { useState } from "react";
import { validarRUT, formatearRUT } from "@/utils/rutValidator";

export default function FormInput({ field, value, error, onChange }) {
  const [rutError, setRutError] = useState("");

  // Lista de campos que deben usar validación de RUT
  // Puede extenderse en el futuro agregando más nombres
  const RUT_FIELD_NAMES = ["rut", "rut_text", "numeroTributario"];
  const isRutField = RUT_FIELD_NAMES.includes(field.name);

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Si el campo tiene autoPrefix (ej: "@"), asegurar que el valor siempre empiece con él
    if (field.autoPrefix) {
      const prefix = field.autoPrefix;
      if (inputValue.length === 0) {
        onChange(field.name, "");
        return;
      }
      const withoutPrefix = inputValue.replace(/^@+/, "");
      onChange(field.name, prefix + withoutPrefix);
      return;
    }

    // Si es un campo RUT, aplicar validación y formateo
    if (isRutField) {
      // Permitir solo números, K y caracteres de formato
      const rutLimpio = inputValue.replace(/[^0-9Kk]/g, "");

      if (rutLimpio.length <= 10) {
        const rutFormateado = formatearRUT(rutLimpio);
        onChange(field.name, rutFormateado);

        // Validar RUT si tiene longitud suficiente
        if (rutLimpio.length >= 8) {
          if (validarRUT(rutFormateado)) {
            setRutError("");
          } else {
            setRutError("RUT inválido");
          }
        } else {
          setRutError("");
        }
      }
    } else {
      // Para campos normales, pasar el valor sin modificar
      onChange(field.name, inputValue);
    }
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-200 mb-2">
        {field.label}
        {field.required && <span className="text-aw-green font-semibold text-lg ml-1">*</span>}
        {field.tips && (
          <p className="text-xs text-aw-green-75">{field.tips}</p>
        )}
      </label>
      <input
        type={field.type || "text"}
        name={field.name}
        value={value || ""}
        onChange={handleChange}
        placeholder={field.placeholder || field.label}
        min={field.min}
        max={field.max}
        maxLength={field.maxLength || null}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 transition-all duration-200 ${
          error || rutError
            ? "border-red-500 focus:ring-red-500"
            : "border-gray-300 focus:ring-aw-bluedark"
        } bg-white text-black`}
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
      {rutError && !error && <p className="text-xs text-red-500 mt-1">{rutError}</p>}
      {field.helpText && !error && (
        <p className="text-xs text-gray-500 mt-1">{field.helpText}</p>
      )}
    </div>
  );
}
